import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/no-data/table-empty.png';
const _hoisted_1 = {
  class: "dict-page common-page"
};
const _hoisted_2 = {
  class: "page-title"
};
const _hoisted_3 = {
  class: "search"
};
const _hoisted_4 = {
  class: "search-form"
};
const _hoisted_5 = {
  class: "dict-list"
};
import { reactive, ref } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import dictDialog from "./components/dict-dialog.vue";
import { deleteDictCategory, getDictCategoryListPage } from "@/service/modules/dict";
export default /*@__PURE__*/_defineComponent({
  __name: 'list',
  setup(__props) {
    const dictList = ref([]);
    const dictDialogVisible = ref(false);
    const dictDialogType = ref("add");
    const dictData = ref({});
    const page = reactive({
      page: 1,
      pageSize: 10,
      current: 1,
      limit: 10
    });
    const total = ref(0);
    const form = reactive({
      name: ""
    });
    function handleClearCaseList() {
      form.name = "";
      page.current = 1;
      getDictList();
    }
    function restCaseList() {
      getDictList();
    }
    getDictList();
    async function getDictList() {
      const res = await getDictCategoryListPage({
        ...page,
        ...form
      });
      console.log(123, res);
      // 模拟数据
      dictList.value = res.data.records || [];
      total.value = res.data.total;
    }
    function restData() {
      page.page = 1;
      getDictList();
    }
    async function handleDelete(id) {
      ElMessageBox.confirm("确定要删除该记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        // 处理删除逻辑
        try {
          let res = await deleteDictCategory(id);
          ElMessage.success("删除成功");
          restData();
        } catch {}
      });
    }
    function handleUpdate(item, type) {
      dictDialogType.value = type;
      dictData.value = item;
      // dictData.value.options = [
      //   { id: 1, name: "委保科社1" },
      //   { id: 2, name: "委保科社2" },
      //   { id: 3, name: "委保科社3" },
      // ];
      dictDialogVisible.value = true;
    }
    function handleDictTableCurrentChange(val) {
      page.page = val;
      getDictList();
    }
    function handleUserTableSizeChange(val) {
      page.pageSize = val;
      getDictList();
    }
    function handleOpenDictDialog() {
      dictDialogType.value = "add";
      dictData.value = {};
      dictDialogVisible.value = true;
    }
    function handleCloseDictDialog() {
      dictDialogType.value = "add";
      dictData.value = {};
      dictDialogVisible.value = false;
      restData();
    }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table = _resolveComponent("el-table");
      const _component_proto_pagination = _resolveComponent("proto-pagination");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[3] || (_cache[3] = _createTextVNode(" 健康档案字典 ")), _createVNode(_component_el_button, {
        onClick: handleOpenDictDialog,
        type: "primary",
        style: {
          "margin-left": "5px"
        }
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("新增")])),
        _: 1
      })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form, {
        inline: true,
        model: form,
        class: "demo-form-inline"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "名称",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.name = $event),
            style: {
              "width": "180px"
            },
            placeholder: "请输入名称",
            clearable: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = $event => handleClearCaseList())
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("重置")])),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: restCaseList
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("搜索")])),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_table, {
        data: dictList.value,
        "header-cell-style": {
          background: '#F7F9FB !important',
          color: '#111111',
          height: '42px',
          fontSize: '14px'
        }
      }, {
        empty: _withCtx(() => _cache[8] || (_cache[8] = [_createElementVNode("div", {
          class: "table-empty"
        }, [_createElementVNode("img", {
          class: "no-data",
          src: _imports_0,
          alt: ""
        }), _createElementVNode("div", {
          class: "empty-text"
        }, "暂无数据")], -1)])),
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "id",
          label: "ID",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "name",
          label: "字段名称",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "options",
          label: "选择项",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.items?.map(item => item.name).join(", ")), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_link, {
            class: "m-r-10",
            type: "primary",
            onClick: $event => handleUpdate(scope.row, 'edit')
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("编辑")])),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_link, {
            class: "m-r-10",
            type: "primary",
            onClick: $event => handleUpdate(scope.row, 'options')
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("选择项")])),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _createVNode(_component_proto_pagination, {
        page: page,
        total: total.value,
        onCurrentChange: handleDictTableCurrentChange,
        onSizeChange: handleUserTableSizeChange
      }, null, 8, ["page", "total"])])]), _createVNode(dictDialog, {
        "dialog-visible": dictDialogVisible.value,
        "dialog-type": dictDialogType.value,
        "dict-data": dictData.value,
        onCloseDialog: handleCloseDictDialog
      }, null, 8, ["dialog-visible", "dialog-type", "dict-data"])], 64);
    };
  }
});